var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcCopyFill = function SvgIcCopyFill(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 8.6026V11.4026C10.6654 13.7359 9.73203 14.6693 7.3987 14.6693H4.5987C2.26536 14.6693 1.33203 13.7359 1.33203 11.4026V8.6026C1.33203 6.26927 2.26536 5.33594 4.5987 5.33594H7.3987C9.73203 5.33594 10.6654 6.26927 10.6654 8.6026Z",
    fill: "#758098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.3998 1.33594H8.59984C6.29984 1.33594 5.36651 2.24927 5.33984 4.5026H7.39984C10.1998 4.5026 11.4998 5.8026 11.4998 8.6026V10.6626C13.7532 10.6359 14.6665 9.7026 14.6665 7.4026V4.6026C14.6665 2.26927 13.7332 1.33594 11.3998 1.33594Z",
    fill: "#758098"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCopyFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-copy-fill.48e0cf5f.svg";
export { ForwardRef as ReactComponent };